{
  "familyId": "TOPO-NL-STEDEN-REGIO",
  "questions": [
    {
      "id": "TOPO-NL-STEDEN-REGIO-001",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Almere is een van de snelst groeiende steden van Nederland. In welke provincie ligt Almere?",
      "options": [
        "Flevoland",
        "Noord-Holland",
        "Utrecht",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Almere in Flevoland",
            "content": "Almere ligt in Flevoland, de jongste provincie. Almere is gebouwd op land dat is ingepolderd uit het IJsselmeer. Het is de grootste stad van Flevoland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "almere_flevoland",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Almere ligt in Flevoland. Het is de grootste stad van deze jongste provincie en een van de snelst groeiende steden van Nederland.",
        "solutionSteps": [
          "Almere ligt in Flevoland (de jongste provincie)",
          "Almere is de grootste stad van Flevoland",
          "Lelystad is de hoofdstad van Flevoland"
        ],
        "distractorExplanations": {
          "0": "Goed! Almere ligt in Flevoland.",
          "1": "Almere ligt dicht bij Amsterdam (Noord-Holland), maar het hoort bij Flevoland.",
          "2": "Utrecht ligt ten zuiden van Flevoland. Almere hoort bij Flevoland.",
          "3": "Gelderland grenst aan Flevoland, maar Almere ligt in Flevoland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-001-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-001-OPT2",
            "optionIndex": 2,
            "label": "Utrecht ligt ten zuiden van Flevoland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-002",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "In welk deel van Overijssel ligt Enschede?",
      "options": [
        "In Twente, in het oosten",
        "In de Kop van Overijssel, in het noorden",
        "In Salland, in het midden",
        "In het westen, bij het IJsselmeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Enschede in Twente",
            "content": "Enschede ligt in Twente, het oostelijke deel van Overijssel, dicht bij de Duitse grens. Andere steden in Twente zijn Hengelo en Almelo.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "enschede_twente",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Enschede ligt in Twente, het oostelijke deel van Overijssel, dicht bij de Duitse grens. Twente is een regio met ook Hengelo, Almelo en Oldenzaal.",
        "solutionSteps": [
          "Overijssel heeft drie regio's: Kop van Overijssel, Salland en Twente",
          "Enschede ligt in Twente (oosten, bij Duitsland)",
          "Andere Twentse steden: Hengelo, Almelo"
        ],
        "distractorExplanations": {
          "0": "Goed! Enschede ligt in Twente, in het oosten van Overijssel.",
          "1": "De Kop van Overijssel ligt in het noorden (bij Kampen en Steenwijk). Enschede ligt in het oosten, in Twente.",
          "2": "Salland ligt in het midden van Overijssel (bij Deventer en Raalte). Enschede ligt oostelijker, in Twente.",
          "3": "Het westen van Overijssel grenst niet aan het IJsselmeer op die manier. Enschede ligt juist in het oosten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-002-OPT1",
            "optionIndex": 1,
            "label": "Enschede ligt in het oosten, in Twente"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-002-OPT2",
            "optionIndex": 2,
            "label": "Enschede ligt oostelijker, in Twente"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-002-OPT3",
            "optionIndex": 3,
            "label": "Enschede ligt juist in het oosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-003",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Leiden is een bekende universiteitsstad. In welke provincie ligt Leiden?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Utrecht",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Leiden in Zuid-Holland",
            "content": "Leiden ligt in Zuid-Holland. Het heeft de oudste universiteit van Nederland (1575). Andere steden in Zuid-Holland: Den Haag, Rotterdam, Delft, Gouda, Dordrecht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "leiden_zuid_holland",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Leiden ligt in Zuid-Holland en heeft de oudste universiteit van Nederland (opgericht in 1575 door Willem van Oranje).",
        "solutionSteps": [
          "Leiden ligt in Zuid-Holland",
          "Leiden heeft de oudste universiteit van Nederland (1575)"
        ],
        "distractorExplanations": {
          "0": "Goed! Leiden ligt in Zuid-Holland.",
          "1": "Leiden ligt niet in Noord-Holland. Haarlem en Amsterdam liggen in Noord-Holland.",
          "2": "Utrecht heeft ook een universiteit, maar Leiden ligt in Zuid-Holland.",
          "3": "Gelderland ligt in het oosten. Leiden ligt in het westen, in Zuid-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-003-OPT1",
            "optionIndex": 1,
            "label": "Leiden ligt niet in Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-003-OPT3",
            "optionIndex": 3,
            "label": "Gelderland ligt in het oosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-004",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Drachten en Heerenveen zijn steden in welke provincie?",
      "options": [
        "Friesland",
        "Groningen",
        "Drenthe",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Friesland",
            "content": "Drachten en Heerenveen liggen in Friesland. Heerenveen is bekend van het schaatsstadion Thialf. Andere Friese steden: Leeuwarden (hoofdstad), Sneek, Harlingen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "friesland_steden",
      "variantIndex": 4,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Drachten en Heerenveen liggen in Friesland. Heerenveen is bekend van schaatsstadion Thialf. Drachten is een van de grotere plaatsen in Friesland.",
        "solutionSteps": [
          "Drachten en Heerenveen liggen in Friesland",
          "Heerenveen = schaatsstadion Thialf",
          "Hoofdstad van Friesland = Leeuwarden"
        ],
        "distractorExplanations": {
          "0": "Goed! Drachten en Heerenveen liggen in Friesland.",
          "1": "Groningen is de buurprovincie ten oosten van Friesland. Drachten en Heerenveen liggen in Friesland.",
          "2": "Drenthe ligt ten zuiden van Friesland en Groningen.",
          "3": "Overijssel ligt ten zuiden van Friesland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-004-OPT1",
            "optionIndex": 1,
            "label": "Drachten en Heerenveen liggen in Friesland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Drenthe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-004-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt ten zuiden van Friesland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-005",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Nijmegen is de oudste stad van Nederland. In welke provincie ligt Nijmegen?",
      "options": [
        "Gelderland",
        "Noord-Brabant",
        "Limburg",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nijmegen in Gelderland",
            "content": "Nijmegen ligt in Gelderland, aan de Waal. Het is de oudste stad van Nederland (Romeinse oorsprong). Nijmegen is ook bekend van de Vierdaagse.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nijmegen_gelderland",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Nijmegen ligt in Gelderland, aan de Waal. Het is de oudste stad van Nederland (gesticht door de Romeinen). Nijmegen is ook bekend van de Vierdaagse wandeltocht.",
        "solutionSteps": [
          "Nijmegen ligt in Gelderland",
          "Het is de oudste stad van Nederland (Romeinse oorsprong)",
          "Nijmegen ligt aan de Waal"
        ],
        "distractorExplanations": {
          "0": "Goed! Nijmegen ligt in Gelderland.",
          "1": "Nijmegen ligt dicht bij Noord-Brabant, maar het hoort bij Gelderland.",
          "2": "Limburg ligt ten zuiden van Gelderland. Nijmegen ligt in Gelderland.",
          "3": "Utrecht ligt ten westen van Gelderland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-005-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-005-OPT2",
            "optionIndex": 2,
            "label": "Limburg ligt ten zuiden van Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-005-OPT3",
            "optionIndex": 3,
            "label": "Utrecht ligt ten westen van Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-006",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Delft is bekend om Delfts Blauw aardewerk. In welke provincie ligt Delft?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Zeeland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delft in Zuid-Holland",
            "content": "Delft ligt in Zuid-Holland, tussen Den Haag en Rotterdam. Het is bekend om het Delfts Blauw aardewerk en de Technische Universiteit Delft.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "delft_zuid_holland",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Delft ligt in Zuid-Holland, tussen Den Haag en Rotterdam. Het is wereldberoemd om het Delfts Blauw aardewerk.",
        "solutionSteps": [
          "Delft ligt in Zuid-Holland",
          "Het ligt tussen Den Haag en Rotterdam",
          "Bekend om Delfts Blauw aardewerk"
        ],
        "distractorExplanations": {
          "0": "Goed! Delft ligt in Zuid-Holland.",
          "1": "Delft ligt niet in Noord-Holland. Het ligt in Zuid-Holland, tussen Den Haag en Rotterdam.",
          "2": "Zeeland ligt ten zuiden van Zuid-Holland. Delft ligt in Zuid-Holland.",
          "3": "Utrecht ligt ten oosten. Delft ligt in Zuid-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-006-OPT1",
            "optionIndex": 1,
            "label": "Delft ligt niet in Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-006-OPT2",
            "optionIndex": 2,
            "label": "Zeeland ligt ten zuiden van Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-006-OPT3",
            "optionIndex": 3,
            "label": "Utrecht ligt ten oosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-007",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "In welke provincie liggen de steden Winschoten en Delfzijl?",
      "options": [
        "Groningen",
        "Friesland",
        "Drenthe",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Groningen",
            "content": "Winschoten en Delfzijl liggen in de provincie Groningen. Winschoten ligt in het oosten, Delfzijl aan de kust bij de Eems. De hoofdstad van de provincie is de stad Groningen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "groningen_steden",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Winschoten en Delfzijl liggen in de provincie Groningen. Winschoten ligt in het oosten, Delfzijl aan de kust bij de Eems.",
        "solutionSteps": [
          "Winschoten ligt in het oosten van de provincie Groningen",
          "Delfzijl ligt aan de kust, bij de Eems",
          "Beide steden liggen in de provincie Groningen"
        ],
        "distractorExplanations": {
          "0": "Goed! Winschoten en Delfzijl liggen in de provincie Groningen.",
          "1": "Friesland is de buurprovincie ten westen van Groningen.",
          "2": "Drenthe ligt ten zuiden van Groningen.",
          "3": "Overijssel ligt nog verder naar het zuiden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-007-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Friesland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-007-OPT2",
            "optionIndex": 2,
            "label": "Drenthe ligt ten zuiden van Groningen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-007-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt nog verder naar het zuiden"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-008",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Apeldoorn is bekend van Paleis Het Loo. In welke provincie ligt Apeldoorn?",
      "options": [
        "Gelderland",
        "Overijssel",
        "Utrecht",
        "Noord-Holland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Apeldoorn in Gelderland",
            "content": "Apeldoorn ligt in Gelderland, op de Veluwe. Het is bekend van Paleis Het Loo (voormalig koninklijk paleis) en de Apenheul.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "apeldoorn_gelderland",
      "variantIndex": 8,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Apeldoorn ligt in Gelderland, op de Veluwe. Het is bekend van Paleis Het Loo en de Apenheul.",
        "solutionSteps": [
          "Apeldoorn ligt in Gelderland, op de Veluwe",
          "Bekend van Paleis Het Loo en de Apenheul"
        ],
        "distractorExplanations": {
          "0": "Goed! Apeldoorn ligt in Gelderland.",
          "1": "Overijssel grenst aan Gelderland, maar Apeldoorn ligt in Gelderland.",
          "2": "Utrecht ligt ten westen van Gelderland.",
          "3": "Noord-Holland ligt in het westen van Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-008-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Overijssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-008-OPT2",
            "optionIndex": 2,
            "label": "Utrecht ligt ten westen van Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-008-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Noord-Holland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-009",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Gouda is wereldberoemd om zijn kaas. In welke provincie ligt Gouda?",
      "options": [
        "Zuid-Holland",
        "Utrecht",
        "Noord-Holland",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gouda in Zuid-Holland",
            "content": "Gouda ligt in Zuid-Holland. Het is wereldberoemd om de Goudse kaas en de stroopwafels. Gouda heeft ook een bekende kaasmarkt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gouda_zuid_holland",
      "variantIndex": 9,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Gouda ligt in Zuid-Holland. Het is wereldberoemd om de Goudse kaas en de stroopwafels.",
        "solutionSteps": [
          "Gouda ligt in Zuid-Holland",
          "Bekend om Goudse kaas en stroopwafels"
        ],
        "distractorExplanations": {
          "0": "Goed! Gouda ligt in Zuid-Holland.",
          "1": "Utrecht grenst aan Zuid-Holland, maar Gouda ligt in Zuid-Holland.",
          "2": "Alkmaar (Noord-Holland) heeft ook een kaasmarkt, maar Gouda ligt in Zuid-Holland.",
          "3": "Gelderland ligt in het oosten. Gouda ligt in Zuid-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-009-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-009-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-009-OPT3",
            "optionIndex": 3,
            "label": "Gelderland ligt in het oosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-010",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Hilversum staat bekend als 'mediastad'. In welke provincie ligt Hilversum?",
      "options": [
        "Noord-Holland",
        "Utrecht",
        "Zuid-Holland",
        "Flevoland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hilversum in Noord-Holland",
            "content": "Hilversum ligt in Noord-Holland, in het Gooi. Het is de mediastad van Nederland: veel tv- en radiostudio's zitten hier. Veel mensen denken dat Hilversum in Utrecht ligt, maar het hoort bij Noord-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hilversum_noord_holland",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Hilversum ligt in Noord-Holland, in het Gooi. Het is de mediastad van Nederland. Veel mensen denken dat het in Utrecht ligt, maar het hoort bij Noord-Holland.",
        "solutionSteps": [
          "Hilversum ligt in Noord-Holland (in het Gooi)",
          "Het is de mediastad van Nederland",
          "Let op: het ligt dicht bij Utrecht, maar hoort bij Noord-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Hilversum ligt in Noord-Holland.",
          "1": "Veel mensen denken dat Hilversum in Utrecht ligt omdat het dichtbij is, maar het hoort bij Noord-Holland.",
          "2": "Zuid-Holland ligt ten zuiden. Hilversum ligt in Noord-Holland.",
          "3": "Flevoland ligt ten noorden van het Gooi. Hilversum ligt in Noord-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-010-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-010-OPT2",
            "optionIndex": 2,
            "label": "Zuid-Holland ligt ten zuiden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-010-OPT3",
            "optionIndex": 3,
            "label": "Flevoland ligt ten noorden van het Gooi"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-011",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Eindhoven",
            "right": "Noord-Brabant"
          },
          {
            "left": "Zwolle",
            "right": "Overijssel"
          },
          {
            "left": "Middelburg",
            "right": "Zeeland"
          },
          {
            "left": "Assen",
            "right": "Drenthe"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Eindhoven → Noord-Brabant, Zwolle → Overijssel (hoofdstad), Middelburg → Zeeland (hoofdstad), Assen → Drenthe (hoofdstad).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_2",
      "variantIndex": 11,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Eindhoven ligt in Noord-Brabant, Zwolle is de hoofdstad van Overijssel, Middelburg is de hoofdstad van Zeeland, en Assen is de hoofdstad van Drenthe.",
        "solutionSteps": [
          "Eindhoven → Noord-Brabant",
          "Zwolle → Overijssel (hoofdstad)",
          "Middelburg → Zeeland (hoofdstad)",
          "Assen → Drenthe (hoofdstad)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-012",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Leiden",
            "right": "Zuid-Holland"
          },
          {
            "left": "Almere",
            "right": "Flevoland"
          },
          {
            "left": "Nijmegen",
            "right": "Gelderland"
          },
          {
            "left": "Emmen",
            "right": "Drenthe"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Leiden → Zuid-Holland (universiteitsstad), Almere → Flevoland (grootste stad), Nijmegen → Gelderland (oudste stad NL), Emmen → Drenthe (grootste stad).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_3",
      "variantIndex": 12,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Leiden ligt in Zuid-Holland, Almere in Flevoland, Nijmegen in Gelderland, en Emmen in Drenthe.",
        "solutionSteps": [
          "Leiden → Zuid-Holland (oudste universiteit)",
          "Almere → Flevoland (grootste stad van Flevoland)",
          "Nijmegen → Gelderland (oudste stad van Nederland)",
          "Emmen → Drenthe (grootste stad van Drenthe)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-013",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Enschede",
            "right": "Overijssel"
          },
          {
            "left": "Venlo",
            "right": "Limburg"
          },
          {
            "left": "Breda",
            "right": "Noord-Brabant"
          },
          {
            "left": "Drachten",
            "right": "Friesland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Enschede → Overijssel (Twente), Venlo → Limburg (Noord-Limburg), Breda → Noord-Brabant (west), Drachten → Friesland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_4",
      "variantIndex": 13,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Enschede ligt in Overijssel (Twente), Venlo in Limburg, Breda in Noord-Brabant, en Drachten in Friesland.",
        "solutionSteps": [
          "Enschede → Overijssel (in Twente, bij de Duitse grens)",
          "Venlo → Limburg (in Noord-Limburg, aan de Maas)",
          "Breda → Noord-Brabant (in het westen van Brabant)",
          "Drachten → Friesland"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-014",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Alkmaar",
            "right": "Noord-Holland"
          },
          {
            "left": "Dordrecht",
            "right": "Zuid-Holland"
          },
          {
            "left": "Vlissingen",
            "right": "Zeeland"
          },
          {
            "left": "Lelystad",
            "right": "Flevoland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Alkmaar → Noord-Holland (kaasmarkt), Dordrecht → Zuid-Holland (oudste stad van Holland), Vlissingen → Zeeland (havenstad), Lelystad → Flevoland (hoofdstad).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_5",
      "variantIndex": 14,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Alkmaar ligt in Noord-Holland, Dordrecht in Zuid-Holland, Vlissingen in Zeeland, en Lelystad in Flevoland.",
        "solutionSteps": [
          "Alkmaar → Noord-Holland (bekend van de kaasmarkt)",
          "Dordrecht → Zuid-Holland (oudste stad van Holland)",
          "Vlissingen → Zeeland (havenstad op Walcheren)",
          "Lelystad → Flevoland (hoofdstad)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-015",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Deventer",
            "right": "Overijssel"
          },
          {
            "left": "Apeldoorn",
            "right": "Gelderland"
          },
          {
            "left": "Amersfoort",
            "right": "Utrecht"
          },
          {
            "left": "Tilburg",
            "right": "Noord-Brabant"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Deventer → Overijssel (Hanzestad), Apeldoorn → Gelderland (Veluwe), Amersfoort → Utrecht (grootste stad provincie), Tilburg → Noord-Brabant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_6",
      "variantIndex": 15,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Deventer ligt in Overijssel, Apeldoorn in Gelderland, Amersfoort in Utrecht, en Tilburg in Noord-Brabant.",
        "solutionSteps": [
          "Deventer → Overijssel (historische Hanzestad)",
          "Apeldoorn → Gelderland (op de Veluwe, Paleis Het Loo)",
          "Amersfoort → Utrecht (grootste stad van de provincie)",
          "Tilburg → Noord-Brabant"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-016",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan waarmee die stad bekend is.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Gouda",
            "right": "Kaas en stroopwafels"
          },
          {
            "left": "Delft",
            "right": "Delfts Blauw aardewerk"
          },
          {
            "left": "Heerenveen",
            "right": "Schaatsstadion Thialf"
          },
          {
            "left": "Alkmaar",
            "right": "Kaasmarkt"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bekende steden",
            "content": "Gouda = kaas en stroopwafels. Delft = Delfts Blauw aardewerk. Heerenveen = schaatsstadion Thialf. Alkmaar = kaasmarkt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_bekendheid_match",
      "variantIndex": 16,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Gouda is bekend om kaas en stroopwafels, Delft om Delfts Blauw aardewerk, Heerenveen om schaatsstadion Thialf, en Alkmaar om de kaasmarkt.",
        "solutionSteps": [
          "Gouda → Kaas en stroopwafels",
          "Delft → Delfts Blauw aardewerk",
          "Heerenveen → Schaatsstadion Thialf",
          "Alkmaar → Kaasmarkt"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-017",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan waarmee die stad bekend is.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Eindhoven",
            "right": "Technologie (Philips, ASML)"
          },
          {
            "left": "Leiden",
            "right": "Oudste universiteit van Nederland"
          },
          {
            "left": "Nijmegen",
            "right": "Oudste stad van Nederland"
          },
          {
            "left": "Hilversum",
            "right": "Mediastad (tv en radio)"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bekende steden",
            "content": "Eindhoven = technologie (Philips, ASML). Leiden = oudste universiteit (1575). Nijmegen = oudste stad (Romeins). Hilversum = mediastad.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_bekendheid_match_2",
      "variantIndex": 17,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Eindhoven staat bekend om technologie, Leiden om de oudste universiteit, Nijmegen als oudste stad, en Hilversum als mediastad.",
        "solutionSteps": [
          "Eindhoven → Technologie (Philips, ASML)",
          "Leiden → Oudste universiteit van Nederland (1575)",
          "Nijmegen → Oudste stad van Nederland (Romeinse oorsprong)",
          "Hilversum → Mediastad (tv en radio)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-018",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad ligt NIET in de provincie Gelderland?",
      "options": [
        "Deventer",
        "Arnhem",
        "Nijmegen",
        "Apeldoorn"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deventer in Overijssel",
            "content": "Deventer ligt in Overijssel, niet in Gelderland. Arnhem, Nijmegen en Apeldoorn liggen wél in Gelderland. Deventer ligt aan de IJssel, net over de grens met Gelderland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "niet_in_gelderland",
      "variantIndex": 18,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Deventer ligt in Overijssel, niet in Gelderland. Arnhem (hoofdstad), Nijmegen en Apeldoorn liggen wél in Gelderland.",
        "solutionSteps": [
          "Arnhem → Gelderland (hoofdstad) ✓",
          "Nijmegen → Gelderland ✓",
          "Apeldoorn → Gelderland ✓",
          "Deventer → Overijssel ✗ (ligt niet in Gelderland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Deventer ligt in Overijssel, niet in Gelderland.",
          "1": "Arnhem is de hoofdstad van Gelderland en ligt er dus wél in.",
          "2": "Nijmegen ligt in het zuiden van Gelderland, aan de Waal.",
          "3": "Apeldoorn ligt op de Veluwe, in Gelderland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-018-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Arnhem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-018-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Nijmegen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-018-OPT3",
            "optionIndex": 3,
            "label": "Apeldoorn ligt op de Veluwe, in Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-019",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad ligt NIET in de provincie Zuid-Holland?",
      "options": [
        "Haarlem",
        "Rotterdam",
        "Leiden",
        "Gouda"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haarlem in Noord-Holland",
            "content": "Haarlem is de hoofdstad van Noord-Holland, niet van Zuid-Holland. Rotterdam, Leiden en Gouda liggen wél in Zuid-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "niet_in_zuid_holland",
      "variantIndex": 19,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Haarlem is de hoofdstad van Noord-Holland. Rotterdam, Leiden en Gouda liggen in Zuid-Holland.",
        "solutionSteps": [
          "Rotterdam → Zuid-Holland ✓",
          "Leiden → Zuid-Holland ✓",
          "Gouda → Zuid-Holland ✓",
          "Haarlem → Noord-Holland ✗ (ligt niet in Zuid-Holland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Haarlem ligt in Noord-Holland, niet in Zuid-Holland.",
          "1": "Rotterdam ligt in Zuid-Holland (grootste haven van Europa).",
          "2": "Leiden ligt in Zuid-Holland (oudste universiteit).",
          "3": "Gouda ligt in Zuid-Holland (kaasstad)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-019-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Rotterdam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-019-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Leiden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-019-OPT3",
            "optionIndex": 3,
            "label": "Gouda ligt in Zuid-Holland (kaasstad)"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-020",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Kampen en Deventer zijn historische Hanzesteden. In welke provincie liggen ze?",
      "options": [
        "Overijssel",
        "Gelderland",
        "Flevoland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hanzesteden in Overijssel",
            "content": "Kampen en Deventer liggen in Overijssel. Het zijn historische Hanzesteden — steden die in de middeleeuwen handel dreven via de Hanze. Andere Hanzesteden in de buurt: Zwolle, Zutphen, Harderwijk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "hanzesteden_overijssel",
      "variantIndex": 20,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Kampen en Deventer liggen in Overijssel. Het zijn historische Hanzesteden die in de middeleeuwen handel dreven langs de IJssel.",
        "solutionSteps": [
          "Kampen en Deventer liggen in Overijssel",
          "Het zijn Hanzesteden (middeleeuwse handelssteden)",
          "Ze liggen aan de IJssel"
        ],
        "distractorExplanations": {
          "0": "Goed! Kampen en Deventer liggen in Overijssel.",
          "1": "Gelderland heeft ook Hanzesteden (Zutphen, Harderwijk), maar Kampen en Deventer liggen in Overijssel.",
          "2": "Flevoland is de jongste provincie en heeft geen Hanzesteden.",
          "3": "Utrecht ligt ten westen van Overijssel."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-020-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-020-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Flevoland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-020-OPT3",
            "optionIndex": 3,
            "label": "Utrecht ligt ten westen van Overijssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-021",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Roosendaal en Bergen op Zoom liggen in het westen van welke provincie?",
      "options": [
        "Noord-Brabant",
        "Zeeland",
        "Zuid-Holland",
        "Limburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "West-Brabant",
            "content": "Roosendaal en Bergen op Zoom liggen in het westen van Noord-Brabant, dicht bij de grens met Zeeland. Dit deel heet ook wel West-Brabant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "west_brabant_steden",
      "variantIndex": 21,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Roosendaal en Bergen op Zoom liggen in het westen van Noord-Brabant (West-Brabant), dicht bij de grens met Zeeland.",
        "solutionSteps": [
          "Roosendaal en Bergen op Zoom liggen in Noord-Brabant",
          "Ze liggen in het westen, dicht bij Zeeland"
        ],
        "distractorExplanations": {
          "0": "Goed! Beide steden liggen in Noord-Brabant.",
          "1": "Zeeland grenst aan West-Brabant, maar deze steden liggen in Noord-Brabant.",
          "2": "Zuid-Holland ligt ten noorden van Noord-Brabant.",
          "3": "Limburg ligt in het oosten, niet in het westen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-021-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-021-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-021-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Limburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-022",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Sittard en Roermond liggen in welke provincie?",
      "options": [
        "Limburg",
        "Noord-Brabant",
        "Gelderland",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Limburg",
            "content": "Sittard en Roermond liggen in Limburg. Limburg is de lange, smalle provincie in het zuidoosten. Andere Limburgse steden: Maastricht (hoofdstad), Venlo, Heerlen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "limburg_steden",
      "variantIndex": 22,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Sittard en Roermond liggen in Limburg. Roermond is bekend van het Designer Outlet. Sittard ligt in Zuid-Limburg.",
        "solutionSteps": [
          "Sittard en Roermond liggen in Limburg",
          "Limburg is de lange, smalle provincie in het zuidoosten"
        ],
        "distractorExplanations": {
          "0": "Goed! Sittard en Roermond liggen in Limburg.",
          "1": "Noord-Brabant grenst aan Limburg, maar deze steden liggen in Limburg.",
          "2": "Gelderland ligt ten noorden van Limburg.",
          "3": "Overijssel ligt veel noordelijker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-022-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-022-OPT2",
            "optionIndex": 2,
            "label": "Gelderland ligt ten noorden van Limburg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-022-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt veel noordelijker"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-023",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Terneuzen en Zierikzee liggen in welke provincie?",
      "options": [
        "Zeeland",
        "Zuid-Holland",
        "Noord-Brabant",
        "Limburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Zeeland",
            "content": "Terneuzen ligt in Zeeuws-Vlaanderen (het deel van Zeeland ten zuiden van de Westerschelde). Zierikzee ligt op Schouwen-Duiveland. Beide horen bij Zeeland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zeeland_steden",
      "variantIndex": 23,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Terneuzen en Zierikzee liggen in Zeeland. Terneuzen ligt in Zeeuws-Vlaanderen, Zierikzee op het eiland Schouwen-Duiveland.",
        "solutionSteps": [
          "Terneuzen → Zeeland (Zeeuws-Vlaanderen)",
          "Zierikzee → Zeeland (Schouwen-Duiveland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Beide steden liggen in Zeeland.",
          "1": "Zuid-Holland grenst aan Zeeland, maar deze steden liggen in Zeeland.",
          "2": "Noord-Brabant grenst aan Zeeuws-Vlaanderen, maar Terneuzen hoort bij Zeeland.",
          "3": "Limburg ligt in het zuidoosten, ver van Zeeland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-023-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-023-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-023-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Limburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-024",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Zaandam en Hoorn liggen in welke provincie?",
      "options": [
        "Noord-Holland",
        "Zuid-Holland",
        "Flevoland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Noord-Holland",
            "content": "Zaandam en Hoorn liggen in Noord-Holland. Zaandam ligt net boven Amsterdam (Zaanstreek). Hoorn ligt aan het IJsselmeer en is een historische VOC-stad.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "noord_holland_steden",
      "variantIndex": 24,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zaandam en Hoorn liggen in Noord-Holland. Zaandam is bekend van de Zaanse Schans (molens). Hoorn is een historische VOC-stad aan het IJsselmeer.",
        "solutionSteps": [
          "Zaandam → Noord-Holland (Zaanstreek, bij Amsterdam)",
          "Hoorn → Noord-Holland (VOC-stad aan het IJsselmeer)"
        ],
        "distractorExplanations": {
          "0": "Goed! Zaandam en Hoorn liggen in Noord-Holland.",
          "1": "Zuid-Holland ligt ten zuiden. Zaandam en Hoorn liggen in Noord-Holland.",
          "2": "Flevoland ligt aan de andere kant van het IJsselmeer.",
          "3": "Utrecht ligt ten zuiden van Noord-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-024-OPT1",
            "optionIndex": 1,
            "label": "Zuid-Holland ligt ten zuiden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-024-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Flevoland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-024-OPT3",
            "optionIndex": 3,
            "label": "Utrecht ligt ten zuiden van Noord-Holland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-025",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Doetinchem, Harderwijk en Zutphen liggen in welke provincie?",
      "options": [
        "Gelderland",
        "Overijssel",
        "Utrecht",
        "Noord-Brabant"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Gelderland",
            "content": "Doetinchem, Harderwijk en Zutphen liggen in Gelderland. Gelderland is de grootste provincie van Nederland. Doetinchem ligt in de Achterhoek, Harderwijk aan het Veluwemeer, Zutphen aan de IJssel.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gelderland_steden_extra",
      "variantIndex": 25,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Doetinchem, Harderwijk en Zutphen liggen in Gelderland, de grootste provincie van Nederland.",
        "solutionSteps": [
          "Doetinchem → Gelderland (Achterhoek)",
          "Harderwijk → Gelderland (aan het Veluwemeer)",
          "Zutphen → Gelderland (Hanzestad aan de IJssel)"
        ],
        "distractorExplanations": {
          "0": "Goed! Alle drie liggen in Gelderland.",
          "1": "Overijssel grenst aan Gelderland, maar deze steden liggen in Gelderland.",
          "2": "Utrecht ligt ten westen van Gelderland.",
          "3": "Noord-Brabant ligt ten zuiden van Gelderland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-025-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Overijssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-025-OPT2",
            "optionIndex": 2,
            "label": "Utrecht ligt ten westen van Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-025-OPT3",
            "optionIndex": 3,
            "label": "Noord-Brabant ligt ten zuiden van Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-026",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Helmond, Oss en Waalwijk liggen in welke provincie?",
      "options": [
        "Noord-Brabant",
        "Limburg",
        "Gelderland",
        "Zuid-Holland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Noord-Brabant",
            "content": "Helmond, Oss en Waalwijk liggen in Noord-Brabant. Helmond ligt bij Eindhoven, Oss in het noordoosten van Brabant, en Waalwijk in het midden (bij de Efteling).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "brabant_steden_extra",
      "variantIndex": 26,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Helmond, Oss en Waalwijk liggen alle drie in de provincie Noord-Brabant. Helmond ligt in de regio Eindhoven, Oss in het noordoosten van Brabant aan de Maas, en Waalwijk in het midden (dicht bij de Efteling). Noord-Brabant is de grootste provincie in het zuiden van Nederland.",
        "solutionSteps": [
          "Helmond → Noord-Brabant (bij Eindhoven)",
          "Oss → Noord-Brabant (noordoosten, aan de Maas)",
          "Waalwijk → Noord-Brabant (bij de Efteling)"
        ],
        "distractorExplanations": {
          "0": "Goed! Alle drie liggen in Noord-Brabant.",
          "1": "Limburg grenst aan Noord-Brabant, maar deze steden liggen in Brabant.",
          "2": "Gelderland ligt ten noorden van Noord-Brabant.",
          "3": "Zuid-Holland ligt ten noordwesten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-026-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Limburg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-026-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-026-OPT3",
            "optionIndex": 3,
            "label": "Zuid-Holland ligt ten noordwesten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-027",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Harlingen",
            "right": "Friesland"
          },
          {
            "left": "Hoogeveen",
            "right": "Drenthe"
          },
          {
            "left": "Roermond",
            "right": "Limburg"
          },
          {
            "left": "Winterswijk",
            "right": "Gelderland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Harlingen → Friesland (havenstad aan de Waddenzee), Hoogeveen → Drenthe, Roermond → Limburg (Designer Outlet), Winterswijk → Gelderland (Achterhoek, bij de Duitse grens).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_7",
      "variantIndex": 27,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Harlingen ligt in Friesland, Hoogeveen in Drenthe, Roermond in Limburg, en Winterswijk in Gelderland.",
        "solutionSteps": [
          "Harlingen → Friesland (havenstad, veerboot naar Terschelling)",
          "Hoogeveen → Drenthe",
          "Roermond → Limburg (bekend van Designer Outlet)",
          "Winterswijk → Gelderland (Achterhoek, bij Duitse grens)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-028",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Den Helder",
            "right": "Noord-Holland"
          },
          {
            "left": "Terneuzen",
            "right": "Zeeland"
          },
          {
            "left": "Hengelo",
            "right": "Overijssel"
          },
          {
            "left": "Sittard",
            "right": "Limburg"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Den Helder → Noord-Holland (marinebasis, punt van Noord-Holland), Terneuzen → Zeeland (Zeeuws-Vlaanderen), Hengelo → Overijssel (Twente), Sittard → Limburg (Zuid-Limburg).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_8",
      "variantIndex": 28,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Den Helder ligt in Noord-Holland, Terneuzen in Zeeland, Hengelo in Overijssel, en Sittard in Limburg.",
        "solutionSteps": [
          "Den Helder → Noord-Holland (marinebasis, punt van NH)",
          "Terneuzen → Zeeland (Zeeuws-Vlaanderen)",
          "Hengelo → Overijssel (Twente)",
          "Sittard → Limburg (Zuid-Limburg)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-029",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Zoetermeer is een grote stad in de Randstad. In welke provincie ligt Zoetermeer?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Utrecht",
        "Flevoland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoetermeer in Zuid-Holland",
            "content": "Zoetermeer ligt in Zuid-Holland, vlakbij Den Haag. Het is enorm gegroeid als overloopgemeente voor Den Haag.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zoetermeer_zuid_holland",
      "variantIndex": 29,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zoetermeer ligt in Zuid-Holland, vlakbij Den Haag. Het is een grote stad in de Randstad.",
        "solutionSteps": [
          "Zoetermeer ligt in Zuid-Holland",
          "Het ligt vlakbij Den Haag"
        ],
        "distractorExplanations": {
          "0": "Goed! Zoetermeer ligt in Zuid-Holland.",
          "1": "Noord-Holland ligt noordelijker. Zoetermeer ligt in Zuid-Holland.",
          "2": "Utrecht ligt ten oosten van Zoetermeer.",
          "3": "Flevoland ligt veel noordelijker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-029-OPT1",
            "optionIndex": 1,
            "label": "Noord-Holland ligt noordelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-029-OPT2",
            "optionIndex": 2,
            "label": "Utrecht ligt ten oosten van Zoetermeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-029-OPT3",
            "optionIndex": 3,
            "label": "Flevoland ligt veel noordelijker"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-030",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Scheveningen is een bekende badplaats. Bij welke grote stad in Zuid-Holland hoort Scheveningen?",
      "options": [
        "Den Haag",
        "Rotterdam",
        "Leiden",
        "Dordrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Scheveningen bij Den Haag",
            "content": "Scheveningen is een stadsdeel van Den Haag, gelegen aan de Noordzee. Het is de bekendste badplaats van Nederland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "scheveningen_den_haag",
      "variantIndex": 30,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Scheveningen is een stadsdeel van Den Haag. Het ligt direct aan de Noordzeekust en is een zeer bekende badplaats.",
        "solutionSteps": [
          "Scheveningen is een badplaats aan de Noordzee",
          "Het is een stadsdeel van Den Haag",
          "Het ligt in Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Scheveningen hoort bij Den Haag.",
          "1": "Rotterdam heeft Hoek van Holland als badplaats, niet Scheveningen.",
          "2": "Leiden ligt vlakbij de kust (Katwijk), maar Scheveningen hoort bij Den Haag.",
          "3": "Dordrecht ligt landinwaarts en heeft geen strand."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-030-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Rotterdam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-030-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Leiden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-030-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Dordrecht"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-031",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Sneek en Franeker zijn bekende steden van de Elfstedentocht. In welke provincie liggen ze?",
      "options": [
        "Friesland",
        "Groningen",
        "Drenthe",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Friese Elfsteden",
            "content": "Sneek en Franeker liggen in Friesland en zijn onderdeel van de Friese Elfstedentocht. Sneek is ook bekend van de watersport (Sneekweek).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "sneek_franeker_friesland",
      "variantIndex": 31,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Sneek en Franeker liggen in Friesland. Het zijn twee van de Friese elf steden. Sneek is erg bekend om de watersport.",
        "solutionSteps": [
          "Sneek en Franeker zijn Friese steden",
          "Ze horen bij de Elfstedentocht",
          "Ze liggen dus in Friesland"
        ],
        "distractorExplanations": {
          "0": "Goed! Sneek en Franeker liggen in Friesland.",
          "1": "Groningen heeft geen Elfstedentocht.",
          "2": "Drenthe ligt ten zuiden van Groningen en oosten van Friesland.",
          "3": "Overijssel ligt ten zuiden van Drenthe en Friesland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-031-OPT1",
            "optionIndex": 1,
            "label": "Groningen heeft geen Elfstedentocht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-031-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Drenthe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-031-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Overijssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-032",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "In welke provincie liggen de plaatsen Meppel en Coevorden?",
      "options": [
        "Drenthe",
        "Overijssel",
        "Friesland",
        "Groningen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Drenthe",
            "content": "Meppel en Coevorden liggen in het zuiden van Drenthe. Drenthe staat bekend om zijn hunebedden. Andere bekende plaatsen zijn Assen en Emmen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meppel_coevorden_drenthe",
      "variantIndex": 32,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Meppel en Coevorden liggen in Drenthe. Meppel ligt in het zuidwesten en Coevorden in het zuidoosten van de provincie.",
        "solutionSteps": [
          "Meppel en Coevorden liggen in Drenthe",
          "Ze liggen in het zuidelijke deel van de provincie"
        ],
        "distractorExplanations": {
          "0": "Goed! Meppel en Coevorden liggen in Drenthe.",
          "1": "Overijssel grenst aan Drenthe, maar deze plaatsen liggen net ten noorden van de grens, in Drenthe.",
          "2": "Friesland ligt ten westen van Drenthe.",
          "3": "Groningen ligt ten noorden van Drenthe."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-032-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Overijssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-032-OPT2",
            "optionIndex": 2,
            "label": "Friesland ligt ten westen van Drenthe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-032-OPT3",
            "optionIndex": 3,
            "label": "Groningen ligt ten noorden van Drenthe"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-033",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Ede, Tiel en Wageningen liggen in welke provincie?",
      "options": [
        "Gelderland",
        "Utrecht",
        "Noord-Brabant",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Gelderland",
            "content": "Ede (Veluwe), Tiel (Betuwe) en Wageningen liggen allemaal in Gelderland. Wageningen heeft een bekende universiteit en Tiel is bekend van Flipje.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "ede_tiel_wageningen_gelderland",
      "variantIndex": 33,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Ede, Tiel en Wageningen liggen in Gelderland. Ede ligt op de Veluwe, Tiel in de Betuwe en Wageningen aan de Rijn.",
        "solutionSteps": [
          "Ede ligt op de Veluwe (Gelderland)",
          "Tiel ligt in de Betuwe (Gelderland)",
          "Wageningen ligt aan de Rijn (Gelderland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Deze steden liggen in Gelderland.",
          "1": "Utrecht grenst aan Gelderland, maar deze steden liggen in Gelderland.",
          "2": "Noord-Brabant ligt ten zuiden van de grote rivieren.",
          "3": "Overijssel ligt ten noorden van Gelderland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-033-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-033-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-033-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt ten noorden van Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-034",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Veenendaal, Zeist en Nieuwegein liggen in welke provincie?",
      "options": [
        "Utrecht",
        "Gelderland",
        "Zuid-Holland",
        "Noord-Holland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Utrecht",
            "content": "Veenendaal, Zeist en Nieuwegein liggen in de provincie Utrecht. Nieuwegein ligt direct ten zuiden van de stad Utrecht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "utrecht_steden_extra",
      "variantIndex": 34,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Veenendaal, Zeist en Nieuwegein liggen in de provincie Utrecht. Het zijn grote plaatsen rondom de stad Utrecht en op de Utrechtse Heuvelrug.",
        "solutionSteps": [
          "Nieuwegein ligt ten zuiden van Utrecht",
          "Zeist ligt ten oosten van Utrecht",
          "Veenendaal ligt in het zuidoosten van de provincie Utrecht"
        ],
        "distractorExplanations": {
          "0": "Goed! Deze steden liggen in de provincie Utrecht.",
          "1": "Veenendaal ligt heel dicht bij Gelderland, maar hoort bij Utrecht.",
          "2": "Zuid-Holland ligt ten westen van Utrecht.",
          "3": "Noord-Holland ligt ten noordwesten van Utrecht."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-034-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-034-OPT2",
            "optionIndex": 2,
            "label": "Zuid-Holland ligt ten westen van Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-034-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Noord-Holland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-035",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Purmerend ligt ten noorden van Amsterdam. In welke provincie ligt Purmerend?",
      "options": [
        "Noord-Holland",
        "Flevoland",
        "Zuid-Holland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Purmerend in Noord-Holland",
            "content": "Purmerend ligt in Noord-Holland, in de regio Waterland, ten noorden van Amsterdam.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "purmerend_noord_holland",
      "variantIndex": 35,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Purmerend ligt in Noord-Holland, ten noorden van Amsterdam. Het is een bekende marktstad in de regio Waterland.",
        "solutionSteps": [
          "Purmerend ligt ten noorden van Amsterdam",
          "Amsterdam ligt in Noord-Holland",
          "Dus Purmerend ligt ook in Noord-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Purmerend ligt in Noord-Holland.",
          "1": "Flevoland ligt aan de andere kant van het Markermeer.",
          "2": "Zuid-Holland ligt ten zuiden van Noord-Holland.",
          "3": "Utrecht ligt ten zuidoosten van Noord-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-035-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Flevoland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-035-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-035-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Utrecht"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-036",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Goes is een bekende stad op het schiereiland Zuid-Beveland. In welke provincie ligt Goes?",
      "options": [
        "Zeeland",
        "Zuid-Holland",
        "Noord-Brabant",
        "Friesland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Goes in Zeeland",
            "content": "Goes ligt centraal in Zeeland, op het schiereiland Zuid-Beveland. Andere Zeeuwse steden zijn Middelburg en Vlissingen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "goes_zeeland",
      "variantIndex": 36,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Goes ligt in Zeeland, op het schiereiland Zuid-Beveland. Het is een belangrijke centrumstad voor dat deel van Zeeland.",
        "solutionSteps": [
          "Goes ligt op Zuid-Beveland",
          "Zuid-Beveland is een schiereiland van Zeeland",
          "Goes ligt dus in Zeeland"
        ],
        "distractorExplanations": {
          "0": "Goed! Goes ligt in Zeeland.",
          "1": "Zuid-Holland ligt ten noorden van Zeeland.",
          "2": "Noord-Brabant grenst aan Zeeland, maar Goes ligt echt in Zeeland.",
          "3": "Friesland ligt in het noorden van Nederland, Zeeland in het zuidwesten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-036-OPT1",
            "optionIndex": 1,
            "label": "Zuid-Holland ligt ten noorden van Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-036-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-036-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Friesland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-037",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Weert en Kerkrade liggen in welke provincie?",
      "options": [
        "Limburg",
        "Noord-Brabant",
        "Gelderland",
        "Zeeland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Limburg",
            "content": "Weert ligt in Midden-Limburg en Kerkrade ligt helemaal in het zuidoosten van Limburg, tegen de Duitse grens.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "weert_kerkrade_limburg",
      "variantIndex": 37,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Weert en Kerkrade liggen in Limburg. Weert ligt in het midden van de provincie, en Kerkrade in het uiterste zuidoosten, tegen de Duitse grens.",
        "solutionSteps": [
          "Weert ligt in Midden-Limburg",
          "Kerkrade ligt in Zuid-Limburg",
          "Beide liggen in de provincie Limburg"
        ],
        "distractorExplanations": {
          "0": "Goed! Weert en Kerkrade liggen in Limburg.",
          "1": "Weert grenst aan Noord-Brabant, maar ligt in Limburg.",
          "2": "Gelderland ligt noordelijker.",
          "3": "Zeeland ligt in het zuidwesten van Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-037-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-037-OPT2",
            "optionIndex": 2,
            "label": "Gelderland ligt noordelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-037-OPT3",
            "optionIndex": 3,
            "label": "Zeeland ligt in het zuidwesten van Nederland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-038",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Dronten en Emmeloord liggen in de polders van welke provincie?",
      "options": [
        "Flevoland",
        "Noord-Holland",
        "Friesland",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden in Flevoland",
            "content": "Dronten en Emmeloord liggen in Flevoland. Emmeloord is de hoofdplaats van de Noordoostpolder. Dronten ligt in Oostelijk Flevoland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "dronten_emmeloord_flevoland",
      "variantIndex": 38,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Dronten en Emmeloord liggen in Flevoland. Emmeloord ligt in de Noordoostpolder en Dronten in Oostelijk Flevoland.",
        "solutionSteps": [
          "Emmeloord ligt in de Noordoostpolder (Flevoland)",
          "Dronten ligt in Oostelijk Flevoland",
          "Beide liggen in de jongste provincie: Flevoland"
        ],
        "distractorExplanations": {
          "0": "Goed! Dronten en Emmeloord liggen in Flevoland.",
          "1": "Noord-Holland ligt ten westen van Flevoland.",
          "2": "Friesland ligt ten noorden van de Noordoostpolder.",
          "3": "Overijssel grenst aan de Noordoostpolder, maar Emmeloord ligt in Flevoland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-038-OPT1",
            "optionIndex": 1,
            "label": "Noord-Holland ligt ten westen van Flevoland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-038-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Friesland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-038-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Overijssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-039",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Veendam en Stadskanaal liggen in het zuidoosten van welke provincie?",
      "options": [
        "Groningen",
        "Drenthe",
        "Friesland",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Veenkoloniën in Groningen",
            "content": "Veendam en Stadskanaal liggen in de provincie Groningen, in de streek die de Veenkoloniën wordt genoemd.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "veendam_stadskanaal_groningen",
      "variantIndex": 39,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Veendam en Stadskanaal liggen in de provincie Groningen, in het zuidoosten. Dit gebied staat bekend als de Groninger Veenkoloniën.",
        "solutionSteps": [
          "Veendam en Stadskanaal liggen in het zuidoosten van Groningen",
          "Ze horen bij de Groninger Veenkoloniën"
        ],
        "distractorExplanations": {
          "0": "Goed! Ze liggen in Groningen.",
          "1": "Stadskanaal ligt vlakbij de grens met Drenthe, maar hoort bij Groningen.",
          "2": "Friesland ligt ten westen van Groningen.",
          "3": "Overijssel ligt veel zuidelijker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-039-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Drenthe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-039-OPT2",
            "optionIndex": 2,
            "label": "Friesland ligt ten westen van Groningen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-039-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt veel zuidelijker"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-040",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Alphen aan den Rijn ligt centraal in het Groene Hart. In welke provincie ligt deze stad?",
      "options": [
        "Zuid-Holland",
        "Utrecht",
        "Noord-Holland",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alphen aan den Rijn in Zuid-Holland",
            "content": "Alphen aan den Rijn ligt in Zuid-Holland, in het Groene Hart tussen Leiden, Gouda en Utrecht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphen_zuid_holland",
      "variantIndex": 40,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Alphen aan den Rijn ligt in Zuid-Holland, centraal in het Groene Hart.",
        "solutionSteps": [
          "Alphen aan den Rijn ligt in het Groene Hart",
          "Het ligt in de provincie Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Alphen aan den Rijn ligt in Zuid-Holland.",
          "1": "Het ligt dichtbij de grens met Utrecht, maar hoort bij Zuid-Holland.",
          "2": "Noord-Holland ligt noordelijker.",
          "3": "Gelderland ligt veel verder naar het oosten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-040-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-040-OPT2",
            "optionIndex": 2,
            "label": "Noord-Holland ligt noordelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-040-OPT3",
            "optionIndex": 3,
            "label": "Gelderland ligt veel verder naar het oosten"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-041",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Vlaardingen en Schiedam liggen direct naast Rotterdam. In welke provincie liggen ze?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Zeeland",
        "Noord-Brabant"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden bij Rotterdam",
            "content": "Vlaardingen en Schiedam liggen in Zuid-Holland, aan de Nieuwe Maas, direct ten westen van Rotterdam.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vlaardingen_schiedam_zuid_holland",
      "variantIndex": 41,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Vlaardingen en Schiedam liggen in Zuid-Holland, direct naast Rotterdam aan de rivier de Nieuwe Maas.",
        "solutionSteps": [
          "Vlaardingen en Schiedam liggen naast Rotterdam",
          "Rotterdam ligt in Zuid-Holland",
          "Dus Vlaardingen en Schiedam liggen ook in Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Ze liggen in Zuid-Holland.",
          "1": "Noord-Holland ligt noordelijker.",
          "2": "Zeeland ligt zuidelijker.",
          "3": "Noord-Brabant ligt ten zuiden van de rivieren."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-041-OPT1",
            "optionIndex": 1,
            "label": "Noord-Holland ligt noordelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-041-OPT2",
            "optionIndex": 2,
            "label": "Zeeland ligt zuidelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-041-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Noord-Brabant"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-042",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Spijkenisse ligt op het eiland Voorne-Putten. In welke provincie ligt Spijkenisse?",
      "options": [
        "Zuid-Holland",
        "Zeeland",
        "Noord-Brabant",
        "Noord-Holland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Spijkenisse in Zuid-Holland",
            "content": "Spijkenisse ligt in Zuid-Holland, ten zuidwesten van Rotterdam op het eiland Voorne-Putten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "spijkenisse_zuid_holland",
      "variantIndex": 42,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Spijkenisse ligt in Zuid-Holland, ten zuidwesten van Rotterdam op het eiland Voorne-Putten.",
        "solutionSteps": [
          "Spijkenisse ligt ten zuidwesten van Rotterdam",
          "Het hoort bij de provincie Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Spijkenisse ligt in Zuid-Holland.",
          "1": "Zeeland bestaat ook uit eilanden, maar Voorne-Putten hoort bij Zuid-Holland.",
          "2": "Noord-Brabant ligt zuidelijker.",
          "3": "Noord-Holland ligt noordelijker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-042-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-042-OPT2",
            "optionIndex": 2,
            "label": "Noord-Brabant ligt zuidelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-042-OPT3",
            "optionIndex": 3,
            "label": "Noord-Holland ligt noordelijker"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-043",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Gorinchem (ook wel Gorkum genoemd) ligt aan de rivier de Merwede. In welke provincie ligt deze vestingstad?",
      "options": [
        "Zuid-Holland",
        "Gelderland",
        "Noord-Brabant",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gorinchem in Zuid-Holland",
            "content": "Gorinchem ligt in het uiterste zuidoosten van Zuid-Holland, precies waar Zuid-Holland, Gelderland en Noord-Brabant bij elkaar komen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gorinchem_zuid_holland",
      "variantIndex": 43,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Gorinchem ligt in Zuid-Holland. Het ligt in het uiterste zuidoosten van de provincie, vlakbij het drieprovinciënpunt met Gelderland en Noord-Brabant.",
        "solutionSteps": [
          "Gorinchem ligt aan de Merwede",
          "Het ligt in het zuidoosten van Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Gorinchem ligt in Zuid-Holland.",
          "1": "Gorinchem ligt vlakbij Gelderland, maar hoort bij Zuid-Holland.",
          "2": "Noord-Brabant ligt aan de overkant van de rivier (de Merwede).",
          "3": "Utrecht ligt ten noorden van Gorinchem."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-043-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-043-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-043-OPT3",
            "optionIndex": 3,
            "label": "Utrecht ligt ten noorden van Gorinchem"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-044",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Wassenaar en Noordwijk zijn bekende kustplaatsen. In welke provincie liggen ze?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Zeeland",
        "Friesland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kustplaatsen in Zuid-Holland",
            "content": "Wassenaar en Noordwijk liggen aan de kust in Zuid-Holland, ten noorden van Den Haag.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wassenaar_noordwijk_zuid_holland",
      "variantIndex": 44,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Wassenaar en Noordwijk liggen in Zuid-Holland, aan de Noordzeekust ten noorden van Den Haag.",
        "solutionSteps": [
          "Wassenaar en Noordwijk liggen aan de kust",
          "Ze liggen ten noorden van Den Haag",
          "Dus ze liggen in Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Ze liggen in Zuid-Holland.",
          "1": "Zandvoort ligt in Noord-Holland, maar Wassenaar en Noordwijk liggen in Zuid-Holland.",
          "2": "Zeeland heeft ook kustplaatsen (zoals Domburg), maar deze liggen in Zuid-Holland.",
          "3": "Friesland ligt in het noorden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-044-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-044-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-044-OPT3",
            "optionIndex": 3,
            "label": "Friesland ligt in het noorden"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-045",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Het Westland staat bekend om de vele kassen (de Glazen Stad). In welke provincie ligt het Westland?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Noord-Brabant",
        "Zeeland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Westland in Zuid-Holland",
            "content": "Het Westland ligt in Zuid-Holland, tussen Den Haag, Delft en Hoek van Holland. Het staat vol met kassen voor groente en bloemen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "westland_zuid_holland",
      "variantIndex": 45,
      "citoDifficulty": 0.29,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het Westland ligt in Zuid-Holland, tussen Den Haag en Hoek van Holland. Het staat bekend om de glastuinbouw (kassen).",
        "solutionSteps": [
          "Het Westland is de streek met veel kassen",
          "Het ligt tussen Den Haag en Hoek van Holland",
          "Dus het ligt in Zuid-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Westland ligt in Zuid-Holland.",
          "1": "Noord-Holland heeft ook kassen, maar de streek 'het Westland' ligt in Zuid-Holland.",
          "2": "Noord-Brabant ligt zuidelijker.",
          "3": "Zeeland ligt zuidelijker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-045-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-045-OPT2",
            "optionIndex": 2,
            "label": "Noord-Brabant ligt zuidelijker"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-045-OPT3",
            "optionIndex": 3,
            "label": "Zeeland ligt zuidelijker"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-046",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Sneek",
            "right": "Friesland"
          },
          {
            "left": "Meppel",
            "right": "Drenthe"
          },
          {
            "left": "Goes",
            "right": "Zeeland"
          },
          {
            "left": "Purmerend",
            "right": "Noord-Holland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Sneek → Friesland, Meppel → Drenthe, Goes → Zeeland, Purmerend → Noord-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_9",
      "variantIndex": 46,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Sneek ligt in Friesland, Meppel in Drenthe, Goes in Zeeland en Purmerend in Noord-Holland.",
        "solutionSteps": [
          "Sneek → Friesland (Elfstedentocht)",
          "Meppel → Drenthe (zuidwesten van Drenthe)",
          "Goes → Zeeland (Zuid-Beveland)",
          "Purmerend → Noord-Holland (boven Amsterdam)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-047",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Zoetermeer",
            "right": "Zuid-Holland"
          },
          {
            "left": "Ede",
            "right": "Gelderland"
          },
          {
            "left": "Zeist",
            "right": "Utrecht"
          },
          {
            "left": "Kerkrade",
            "right": "Limburg"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Zoetermeer → Zuid-Holland, Ede → Gelderland, Zeist → Utrecht, Kerkrade → Limburg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_10",
      "variantIndex": 47,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zoetermeer ligt in Zuid-Holland, Ede in Gelderland, Zeist in Utrecht en Kerkrade in Limburg.",
        "solutionSteps": [
          "Zoetermeer → Zuid-Holland (bij Den Haag)",
          "Ede → Gelderland (op de Veluwe)",
          "Zeist → Utrecht (bij de stad Utrecht)",
          "Kerkrade → Limburg (in het zuidoosten)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-048",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "matching",
      "question": "Koppel elke stad aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Dronten",
            "right": "Flevoland"
          },
          {
            "left": "Veendam",
            "right": "Groningen"
          },
          {
            "left": "Franeker",
            "right": "Friesland"
          },
          {
            "left": "Tiel",
            "right": "Gelderland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steden en provincies",
            "content": "Dronten → Flevoland, Veendam → Groningen, Franeker → Friesland, Tiel → Gelderland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "steden_prov_match_11",
      "variantIndex": 48,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Dronten ligt in Flevoland, Veendam in Groningen, Franeker in Friesland en Tiel in Gelderland.",
        "solutionSteps": [
          "Dronten → Flevoland (Oostelijk Flevoland)",
          "Veendam → Groningen (Veenkoloniën)",
          "Franeker → Friesland (Elfstedentocht)",
          "Tiel → Gelderland (Betuwe)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-049",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad ligt NIET in Zuid-Holland?",
      "options": [
        "Purmerend",
        "Zoetermeer",
        "Schiedam",
        "Spijkenisse"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Purmerend in Noord-Holland",
            "content": "Purmerend ligt in Noord-Holland, ten noorden van Amsterdam. Zoetermeer, Schiedam en Spijkenisse liggen wél in Zuid-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "niet_in_zuid_holland_2",
      "variantIndex": 49,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Purmerend ligt in Noord-Holland. Zoetermeer, Schiedam en Spijkenisse liggen in Zuid-Holland.",
        "solutionSteps": [
          "Zoetermeer → Zuid-Holland ✓",
          "Schiedam → Zuid-Holland ✓",
          "Spijkenisse → Zuid-Holland ✓",
          "Purmerend → Noord-Holland ✗ (ligt niet in Zuid-Holland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Purmerend ligt in Noord-Holland.",
          "1": "Zoetermeer ligt in Zuid-Holland (bij Den Haag).",
          "2": "Schiedam ligt in Zuid-Holland (bij Rotterdam).",
          "3": "Spijkenisse ligt in Zuid-Holland (bij Rotterdam)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-049-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Zoetermeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-049-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Schiedam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-049-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Spijkenisse"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-STEDEN-REGIO-050",
      "familyId": "TOPO-NL-STEDEN-REGIO",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_steden_regio_nl",
      "questionType": "multiple_choice",
      "question": "Welke stad ligt NIET in Gelderland?",
      "options": [
        "Veenendaal",
        "Ede",
        "Tiel",
        "Wageningen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_steden_regio_nl"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Veenendaal in Utrecht",
            "content": "Veenendaal ligt in de provincie Utrecht, vlakbij de grens met Gelderland. Ede, Tiel en Wageningen liggen wél in Gelderland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "niet_in_gelderland_2",
      "variantIndex": 50,
      "citoDifficulty": 0.39,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Veenendaal ligt in de provincie Utrecht. Ede, Tiel en Wageningen liggen in Gelderland.",
        "solutionSteps": [
          "Ede → Gelderland ✓",
          "Tiel → Gelderland ✓",
          "Wageningen → Gelderland ✓",
          "Veenendaal → Utrecht ✗ (ligt niet in Gelderland)"
        ],
        "distractorExplanations": {
          "0": "Goed! Veenendaal ligt in Utrecht.",
          "1": "Ede ligt in Gelderland (Veluwe).",
          "2": "Tiel ligt in Gelderland (Betuwe).",
          "3": "Wageningen ligt in Gelderland (aan de Rijn)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-050-OPT1",
            "optionIndex": 1,
            "label": "Ede ligt in Gelderland (Veluwe)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-050-OPT2",
            "optionIndex": 2,
            "label": "Tiel ligt in Gelderland (Betuwe)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-STEDEN-REGIO-050-OPT3",
            "optionIndex": 3,
            "label": "Wageningen ligt in Gelderland (aan de Rijn)"
          }
        ]
      }
    }
  ]
}